import React from 'react';
import PublicLegalContentPage from '../../components/public/PublicLegalContentPage';

const AccessibilityPage = () => (
  <PublicLegalContentPage
    slug="accessibility"
    seoTitle="Accessibility Statement | Pleerity Enterprise Ltd"
    seoDescription="Pleerity is committed to ensuring digital accessibility for people with disabilities."
    canonicalUrl="/accessibility"
  />
);

export default AccessibilityPage;
